import Index from '../../pages/qingyu/duanwu2023/index'

const base = 'duanwu2023';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/qingyu/duanwu2023.js